import SectionHub from '@/components/docs/SectionHub';

export default function ClientLibrariesHub() {
  return <SectionHub sectionPath="client-libraries" />;
}
